module.exports = __webpack_public_path__ + "static/media/wordmark.5bc14fbc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/wordmark.svg
// module id = 387
// module chunks = 0